import React from 'react'
import styles from './DealPrice.module.css'
import { formatMoney } from '../sections/Sale/saleFormat'

// Deal price block, one look for the shop deal cards, the sale page deal cards
// and the sale hero: the deal price large (Kanit, the "VRS November Sales"
// heading style), the regular price struck through, the % off chip and a
// "You save" line. Dark surface by default; theme "light" is the paper deal
// popup. Prices are backend-shaped ({ priceCents, currency }); with no lower
// deal price it shows the price alone.
//   size  "sm" (deal popup) | "md" (shop card) | "lg" (sale page card) | "xl" (sale hero)
function DealPrice({ price, regular, size = 'md', theme = 'dark', className, showSave = true }) {
  if (!price || !Number.isFinite(price.priceCents)) return null
  const discounted = regular && Number.isFinite(regular.priceCents) && regular.priceCents > price.priceCents
  const saving = discounted ? { priceCents: regular.priceCents - price.priceCents, currency: price.currency || regular.currency } : null
  const percent = discounted ? Math.round((1 - price.priceCents / regular.priceCents) * 100) : 0
  return (
    <div className={[styles.block, styles[size], theme === 'light' ? styles.light : null, className].filter(Boolean).join(' ')}>
      <div className={styles.row}>
        <span className={styles.price}>{formatMoney(price)}</span>
        {discounted && <s className={styles.was} aria-label={`Regular price ${formatMoney(regular)}`}>{formatMoney(regular)}</s>}
        {percent > 0 && <span className={styles.pct}>-{percent}%</span>}
      </div>
      {saving && showSave && (
        <span className={styles.save}>
          You save <strong>{formatMoney(saving)}</strong>
        </span>
      )}
    </div>
  )
}

export default DealPrice
